export default {
      id: "shipment__temperature-usage",
      viewBox: "0 0 32 28",
      url: __webpack_public_path__ + "img/icons.svg#shipment__temperature",
      toString: function () {
        return this.url;
      }
    }